import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const config = {
    apiKey: "AIzaSyBajIciW1bPSFgsYX-GNDSjZM2GaYjNdNQ",
    authDomain: "easy-c2d.firebaseapp.com",
    databaseURL: "https://easy-c2d.firebaseio.com",
    projectId: "easy-c2d",
    storageBucket: "easy-c2d.appspot.com",
    messagingSenderId: "641555484341",
    appId: "1:641555484341:web:41ffe7f20a64eb759238fc",
    measurementId: "G-HS5P4NJR3M"
};

const app = initializeApp(config);

// Don't call any browser API here
// Lazy-load messaging: only create it when you call this function in the browser
// Lazy getter function
export const getFirebaseMessaging = () => {
    if (typeof window === "undefined") return null; // SSR safety
    return getMessaging(app);
};
